// Sirket bilgileri. Iletisim sayfasi (src/views/Contact/Index.js), footer ve
// ileride eklenecek JSON-LD Organization isaretlemesi bu tek kaynagi kullanir.

export const company = {
    name: 'GloworKs',
    legalName: 'GLOWORKS DANIŞMANLIK LİMİTED ŞİRKETİ',
    email: 'support@gloworkspartner.com',
    address: {
        street: 'Mesa Koz Sahrayı Cedit Mah., Atatürk Cad., No: 69, Kat. 18 D. 244',
        district: 'Kadıköy',
        city: 'İstanbul',
        country: 'Türkiye',
        countryCode: 'TR',
    },
};

// Adres iki satir halinde gosteriliyor.
export const addressLines = [
    company.address.street,
    `${company.address.district} / ${company.address.city} / ${company.address.country}`,
];

export const addressOneLine = addressLines.join(', ');

// Haritada aratilacak metin. Bina adi ("Mesa Koz") tek basina daha isabetli
// sonuc verdigi icin daire/kat bilgisi disarida birakildi.
const MAPS_QUERY = 'Mesa Koz, Atatürk Cad. No:69, Sahrayıcedit, Kadıköy, İstanbul';

// Yol tarifi baglantisi (yeni sekmede Google Haritalar'i acar).
export const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(MAPS_QUERY)}`;

// Sayfaya gomulu harita. Bu bicim API anahtari istemez, adresi aratip gosterir.
// Dogru pin bulununca Google Haritalar'da "Paylas > Harita yerlestir" ile alinan
// iframe src'si buraya oldugu gibi yapistirilabilir; baska yeri degistirmek
// gerekmez.
export const mapsEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(MAPS_QUERY)}&hl=en&z=17&output=embed`;
